import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const ExportButtons = ({ data, fileName = 'export' }) => {
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const fileData = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(fileData, `${fileName}.xlsx`);
  };

  return (
    <button className="btn btn-success btn-sm" onClick={exportToExcel}><i className="ri-file-excel-2-fill"></i> Export</button>
  );
};

export default ExportButtons;
